// Maakt elke slide in de Slideshow-sectie volledig klikbaar naar de link van de
// (visueel verborgen) knop binnen die slide. Zie sections/slideshow.liquid voor de
// bijbehorende CSS die de knop verbergt.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.slideshow__slide').forEach(function (slide) {
    var link = slide.querySelector('.media-with-overlay__overlay a.button[href]');
    if (!link) return;
 
    slide.addEventListener('click', function (event) {
      // Als er ooit weer een zichtbare link/knop in de slide staat, diens eigen
      // klikgedrag niet overschrijven.
      if (event.target.closest('a')) return;
      window.location.href = link.getAttribute('href');
    });
  });
});